import React from "react";

import GroupController from "./components/Group";
import Warning from "./components/Warning";
import Header from "./components/Header";
import Tabs from "../Tabs";

const Builder = ({
  className = "",
  warning,
  header,
  groups = {
    all: [],
    left: [],
    right: [],
  },
}) => {
  // Рендер одного элемента группы (объекта с data/items или React-элемента)
  const renderGroup = (group, key) => {
    if (!group) return null;

    if (React.isValidElement(group)) return group;

    if (group.type === "tabs") {
      return (
        <Tabs
          key={key}
          tabs={(group.tabs ?? []).map((tab, i) => ({
            title: tab.title || "",
            content: (
              <div className="tab-groups">
                {(tab.items ?? []).map(
                  (item, j) =>
                    React.isValidElement(item) ? (
                      item
                    ) : item && item.data ? (
                      <GroupController key={j} {...item} />
                    ) : null // Если нет data, рендерим null
                )}
              </div>
            ),
            afterContent: tab.afterContent || null,
          }))}
        />
      );
    }

    return group.data ? <GroupController key={key} {...group} /> : null;
  };

  return (
    <section className={`Settings ${className}`}>
      {warning && <Warning message={warning} />}
      {header && <Header {...header} key={header.lineTitle} />}

      <div className="Settings__groups" key={1}>
        {groups.all && groups.all.length > 0 ? (
          <div className="expanded-all">
            {groups.all.map((group, index) => renderGroup(group, index))}
          </div>
        ) : (
          (groups.left || groups.right) && (
            <>
              {groups.left && (
                <div className="expanded-left">
                  {groups.left.map((group, index) =>
                    renderGroup(group, "l" + index)
                  )}
                </div>
              )}
              {groups.right && (
                <div className="expanded-right">
                  {groups.right.map((group, index) =>
                    renderGroup(group, "r" + index)
                  )}
                </div>
              )}
            </>
          )
        )}
      </div>
    </section>
  );
};

export default Builder;
